<script lang="ts">
export default defineComponent({
  name: 'FocusTrap',
  props: {
    as: { type: String, default: 'div' },
    focusAfterClosed: { type: Object as PropType<HTMLElement | null>, required: false },
    initialFocus: { type: Object as PropType<HTMLElement | null>, default: null }
  },
  setup(props, { slots }) {
    const { as } = props
    const { focusAfterClosed, initialFocus } = toRefs(props)

    const container = ref<HTMLElement | null>(null)

    useFocusTrap(container, initialFocus)

    onUnmounted(() => {
      focusAfterClosed.value?.focus()
    })
    
    return () => 
      h(
        as, 
        { 
          ref: container
        }, 
        slots.default!({})
      )
  },
})
</script>